module.exports = __webpack_public_path__ + "img/003-architect.da752b44.png";